<template>

    <div class="mx-sm-1 mt-9">

      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h3 class="card-title fw-bold mb-0">Journal des Ventes</h3>
          <div class="card-options d-flex gap-2">
            <div class="d-flex gap-2">
              <input type="date" v-model="selectedDate" class="form-control w-auto" />
              <button class="btn btn-outline-secondary" @click="resetDateFilter">
                <i class="fe fe-x me-1"></i> Réinitialiser
              </button>
              <button class="btn btn-outline-primary" @click="exportToPDF">
                <i class="fe fe-printer me-2"></i> Exporter PDF
              </button>
            </div>
          </div>
        </div></div>

    <div class="card mt-3">
      <div class="card-header">
        <div v-if="selectedDate" class="mb-2">
          <span class="badge bg-primary">
            {{ sales.length }} vente{{ sales.length > 1 ? 's' : '' }} trouvée{{ sales.length > 1 ? 's' : '' }} pour le {{ formattedSelectedDate }}
          </span>
        </div>
      </div>
      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :items="sales"
            :filterableFields="filterableFields"
            :loading="loading"
            enable-export
        >
          <template #cell-reference="{ item }">
            <span class="text-primary fw-bold">{{ item.reference }}</span>
          </template>

          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount.toFixed(2) }} FCFA
          </template>

          <template #cell-saleDate="{ item }">
            {{ new Date(item.saleDate).toLocaleString() }}
          </template>

          <template #cell-saleType="{ item }">
  <span class="badge bg-info">
    {{ item.saleType || 'AFFILIATE' }}
  </span>
          </template>

          <template #cell-status="{ item }">
            <span class="badge"
                  :class="{
                'bg-success': item.status === 'VALIDATED',
                'bg-warning': item.status === 'PENDING',
                'bg-danger': item.status === 'REJECTED'
              }">
              {{ item.status }}
            </span>
          </template>
        </TableWithFilters>
      </div>
    </div>
  </div>
</template>

<script>
  import jsPDF from "jspdf";
  import autoTable from "jspdf-autotable";
  import TableWithFilters from "@/components/TableWithFilters.vue";
  import {journalSaleColumns, journalSaleFilterableFields} from "../../../helpers/constants";

  export default {
    name: "JournalVentesPage",
    components: { TableWithFilters },
    data() {
      return {
        loading: false,
        allValidatedSales: [],
        sales: [],
        selectedDate: null,
        columns: journalSaleColumns,
        filterableFields: journalSaleFilterableFields

      };
    },
    computed: {
      formattedSelectedDate() {
        if (!this.selectedDate) return '';
        const d = new Date(this.selectedDate);
        return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }
    },
    watch: {
      selectedDate() {
        this.applyDateFilter();
      }
    },
    methods: {
      resetDateFilter() {
        this.selectedDate = null;
      },
      loadSales() {
        this.loading = true;
        this.$http.get("/sales")
            .then(({ data }) => {
              this.allValidatedSales = data
                  .filter(sale => sale.status === 'VALIDATED')
                  .map(sale => ({
                    ...sale,
                    saleType: sale.saleType || 'AFFILIATE'
                  }));
              this.applyDateFilter(); // appliquer filtre si date sélectionnée
            })
            .catch(err => console.error("Erreur chargement journal ventes :", err))
            .finally(() => this.loading = false);
      },

      applyDateFilter() {
        if (!this.selectedDate) {
          this.sales = this.allValidatedSales;
        } else {
          const selected = new Date(this.selectedDate);
          this.sales = this.allValidatedSales.filter(sale => {
            const saleDate = new Date(sale.saleDate);
            return (
                saleDate.getFullYear() === selected.getFullYear() &&
                saleDate.getMonth() === selected.getMonth() &&
                saleDate.getDate() === selected.getDate()
            );
          });
        }
      },

      exportToPDF() {
        const doc = new jsPDF();
        const today = new Date().toLocaleDateString();

        // Titre + date
        doc.setFontSize(18);
        doc.text("📋 Journal des Ventes", 14, 20);
        doc.setFontSize(11);
        doc.setTextColor(100);
        doc.text(`Date d'édition : ${today}`, 14, 27);

        autoTable(doc, {
          startY: 35,
          head: [["Référence", "Client", "Vendeur", "Type", "Montant", "Statut", "Date"]],
          body: this.sales.map(item => [
            item.reference,
            item.clientName || "-",
            item.sellerName || "-",
            item.saleType || 'AFFILIATE',
            `${item.totalAmount.toFixed(2)} FCFA`,
            item.status,
            new Date(item.saleDate).toLocaleString()
          ]),
          styles: { fontSize: 9 },
          headStyles: { fillColor: [41, 128, 185], textColor: 255 },
          columnStyles: {
            4: { halign: 'right' },
            6: { fontStyle: 'italic' }
          },
          didDrawPage: (data) => {
            const pageHeight = doc.internal.pageSize.height;
            doc.setFontSize(9);
            doc.setTextColor(150);
            doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, pageHeight - 10);
          }
        });

        doc.save(`journal-ventes-${today.replaceAll('/', '-')}.pdf`);
      }
    },
    mounted() {
      this.loadSales();
    }
  };
</script>
